import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { AccordionContextType } from './types';

const AccordionContext = createContext<AccordionContextType | null>(null);

export const useAccordionContext = () => {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error(
      'useAccordionContext must be used within an AccordionProvider'
    );
  }
  return context;
};

interface AccordionProviderProps {
  children: ReactNode;
  initialExpandedId?: string | false;
}

export const AccordionProvider = ({
  children,
  initialExpandedId = false,
}: AccordionProviderProps) => {
  const [expandedId, setExpandedId] = useState<string | false>(
    initialExpandedId
  );

  // Reset expanded state when initialExpandedId changes
  useEffect(() => {
    setExpandedId(initialExpandedId);
  }, [initialExpandedId]);

  return (
    <AccordionContext.Provider value={{ expandedId, setExpandedId }}>
      {children}
    </AccordionContext.Provider>
  );
};
